import {
    React,Component,BootstrapTable,
    paginationFactory,Button, ButtonToolbar, Card, 
    Form, Col, Row, axios, Container, Banner, Typeahead, TimePicker,
    cellEditFactory, Type, moment, NavLink, Alert, AppConfiguration,
    NoserLoading, Noser, sizePerPageRenderer, DatePicker, Modal, Tabs, Tab
} 
from '../../../noser-hris-component';

class ReGeneratePayFileModal extends Component {
    constructor(props) {
        super(props)
        this.module = React.createRef();
        this.submodule = React.createRef();
        this.state = {
            userinfo    :   JSON.parse(sessionStorage.getItem("userData")),
            isloading   :   false,
            isshow      :   false,
            alerttype   :   "",
            message     :   "",
            color       :   "",
            fade        :   true,
            
            clientId    :   '',
            clientName  :   '',
            periodId    :   '',
            periodName  :   '',
            isHold      :   '1',
            selectedEmployeeId : "",

            bdoBatchNo	:   "",
            mlBatchNo	:   "",
            mbBatchNo	:   "",
            palawanBatchNo: "",
            ubBatchNo	:   "",

            employeeDDL :   [],
            employeeGRID:   [],

            bdoGRID     :   [],
            mlGRID      :   [],
            mbGRID      :   [],
            palawanGRID :   [],
            ubGRID      :   [],

            payPeriodListAutocomplete : [],
            combineDataw : [],
            PayrollFilesdata : [],
            filteredBatch : [],
            

            //clientListAutocomplete      :   [],

            disablesubmit:   false
        }
    }
    componentDidMount(){
        this.state.userinfo = JSON.parse(sessionStorage.getItem("userData"))
        this.props.onRefModal(this)
        //this.getClientList()
    }
    componentWillUnmount() {
        this.props.onRefModal(undefined)
    }
    initialize=(e)=>{
        this.setState({
            userinfo    :   JSON.parse(sessionStorage.getItem("userData")),
            isloading   :   false,
            isshow      :   false,
            alerttype   :   "",
            message     :   "",
            color       :   "",
            fade        :   true,
            
            clientId    :   e.clientId !== "" ? e.clientId : "",
            clientName  :   e.clientName !== "" ? e.clientName : "",
            periodId    :   e.periodId !== "" ? e.periodId : "",
            periodName  :   e.periodName  !== "" ? e.periodId : "",
            isHold      :   '3',

            bdoBatchNo	:   e.bdoBatchNo  !== "" ? e.bdoBatchNo : "",
            mlBatchNo	:   e.mlBatchNo  !== "" ? e.mlBatchNo : "",
            mbBatchNo	:   e.mbBatchNo  !== "" ? e.mbBatchNo : "",
            palawanBatchNo: e.palawanBatchNo  !== "" ? e.palawanBatchNo : "",
            ubBatchNo	:   e.ubBatchNo  !== "" ? e.ubBatchNo : "",
            clientListAutocomplete : e.clientListAutocomplete ,
            employeeDDL :   [],
            employeeGRID:   [],

            bdoGRID     :   [],
            mlGRID      :   [],
            mbGRID      :   [],
            palawanGRID :   [],
            ubGRID      :   [],

            disablesubmit:   false
        })
        console.log("eeeeeeee")
        console.log(e)
        //this.GetPayrollFiles(e)
        //this.GetDataGrid()
        this.GetEmployeeProfileFilter2()
    };

    /* getClientList(){
        this.setState({
            isloading   :   true
        })
        const sleep = (milliseconds) => {return new Promise(resolve => setTimeout(resolve, milliseconds))}

        const getParams = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId,
        }
        axios
        .post(AppConfiguration.Setting().noserapiendpoint + "Client/GetClientList", getParams)
        .then(res => {
            console.log(res.data.clients)
            sleep(1000).then(() => {
                this.setState({
                    clientListAutocomplete      :   res.data.clients ? res.data.clients     :   [],
                    isloading                   :   false
                })
            })
        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true
            })
        })
    }; */

    onChangeClientList = (e) => {
        if(e.length == 0) {
            this.state.selectedClientId     =   ""
            this.state.selectedClientName   =   ""
            return
        } 
        this.state.selectedClientId         =   e[0].id
        this.state.selectedClientName       =   e[0].name
        this.state.isSpecial = e[0].isSpecial
        this.GetPayPeriodList()
    };
   

    GetPayPeriodList = async() => {
        
        this.setState({isloading:true})
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.selectedClientId,
            "UserId"        :   this.state.userinfo.userId,
            "EmployeeId"    :   this.state.selectedEmployeeId ? this.state.selectedEmployeeId : "",
            "IsProcessed"   :   "1"
        };
        let api = ""
        console.log("params")
        console.log(params)
        if(this.state.isSpecial==="0"){
            api = "Timekeeping/GetPayrollPeriods"
        }
        else{
            api = "Timekeeping/GetSpecialPayrollPeriods"
        }
        await axios
        .post(
            AppConfiguration.Setting().noserapiendpoint + api,  params
        )
        .then(res => {
            const data = res.data;
            this.setState({
                payPeriodListAutocomplete   :   data.payrollPeriods,
                isloading       :   false 
            })
        })
        //this.GetEmployeeProfileFilter2()
    }

    onChangePayPeriod = (e) => {
        console.log(e)

        if(e.length == 0) {
            this.state.payPeriodSelectedId = ""
            this.state.selectedPayPeriodName = ""
            this.setState({combineDataw : []})
            return
        } 

        this.state.payPeriodSelectedId = e[0].periodId
        this.state.selectedPayPeriodName = e[0].payPeriod
        let periodId =  e[0].periodId
        //let payPeriod = e[0].payPeriod
        console.log(periodId)
        this.setState({
            combineDataw: this.state.employeeDDL.filter(x=>x.payPeriodId===e[0].periodId)
        })
        //this.GetPayrollFiles(periodId)
        this.GetEmployeeProfileFilter(periodId)
    }

    /* GetPayrollFiles = async(periodId) =>{
        console.log(periodId)
        let tmpperiodId = periodId
        this.setState({isloading:true})

        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.selectedClientId,
            "UserId"        :   this.state.userinfo.userId,
            "PayPeriodId"    :  periodId,
        }
        console.log(" GetPayrollFiles params")
        console.log(params)
        await axios
        .post(AppConfiguration.Setting().noserapiendpoint + "Accounting/GetPayrollFiles", params)
        .then(res => {
            const data = res.data
            let tempArr = []
            tempArr.push(data)

          
            this.setState({
                isloading       :   false,
                PayrollFilesdata : data
            })
            this.GetEmployeeProfileFilter(tmpperiodId)
            // this.setState({
            //     bdoDataList         :   data.payrollFilesBDO,
            //     metroBankDataList   :   data.payrollFilesMetroBank,
            //     mlListData          :   data.payrollFilesML,
            //     palawanListData     :   data.payrollFilesPalawan,
            //     ubListData          :   data.payrollFilesUB,
            //     lbListData          :   data.payrollFilesLB,
            //     gcashListData       :   data.payrollFilesGCash,
            //     isloading           :   false,
            // })
            // this.setState({
            //     employeeDDL :   data.employeePayrolls,
            //     employeeGRID:   data.employeePayrolls,
            //     bdoGRID     :   data.employeePayrolls.filter(x=>x.payCardTypeId==="2"),
            //     mlGRID      :   data.employeePayrolls.filter(x=>x.payCardTypeId==="4"),
            //     mbGRID      :   data.employeePayrolls.filter(x=>x.payCardTypeId==="6"),
            //     palawanGRID :   data.employeePayrolls.filter(x=>x.payCardTypeId==="15"),
            //     ubGRID      :   data.employeePayrolls.filter(x=>x.payCardTypeId==="14"),
            //     isloading   :   false,
            // })
            if(data.status=="0"){
                this.setState({
                    isloading       :   false,
                    alerttype       :   "Error!",
                    isshow          :   true,
                    color           :   "danger",
                    message         :   data.message,
                    fade            :   true
                })
            }
        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true
            })
        })
    };
    */
    GetEmployeeProfileFilter = async(periodId) =>{
        console.log(periodId)
        this.setState({isloading:true})

        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.selectedClientId,
            "UserId"        :   this.state.userinfo.userId,
        }
        console.log(" GetEmployeeProfileFilter params")
        console.log(params)
        await axios
        .post(AppConfiguration.Setting().noserapiendpoint + "Employee/GetEmployeeProfileFilter", params)
        .then(res => {
            const data = res.data
            let tempArr = []
            tempArr.push(data)
            let tmpobj = []
            tempArr.forEach(element => {
                element.profiles.forEach(element2 => {
                    element2.amount = ""
                    element2.remarks = ""
                    tmpobj.push(element2)
                });
               
            });
            console.log("tempArr")
            console.log(tempArr)
            console.log("tmpobj")
            console.log(tmpobj)

            console.log(tmpobj.filter(x=>x.payPeriodId===periodId && x.status === "ACTIVE"))
            

            console.log(tmpobj.filter(x=>x.payPeriodId===periodId))
            this.setState({
                isloading       :   false,
                employeeDDL : tmpobj.filter(x=>x.payPeriodId===periodId && x.status === "ACTIVE"),
                combineDataw : tmpobj.filter(x=>x.payPeriodId===periodId && x.status === "ACTIVE")
            })
            
            if(data.status=="0"){
                this.setState({
                    isloading       :   false,
                    alerttype       :   "Error!",
                    isshow          :   true,
                    color           :   "danger",
                    message         :   data.message,
                    fade            :   true
                })
            }
        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true
            })
        })
    };
    GetEmployeeProfileFilter2 = async() =>{
        //console.log(tmpperiodId)
        this.setState({isloading:true})

        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   "101",
            "UserId"        :   "39965",
        }
        console.log(" GetEmployeeProfileFilter params")
        console.log(params)
        await axios
        
        .post(AppConfiguration.Setting().noserapiendpoint + "Employee/GetEmployeeList", params)

       // .post(AppConfiguration.Setting().noserapiendpoint + "Employee/GetEmployeeProfileFilter", params)
        .then(res => {
            const data = res.data
            console.log("Employee/GetEmployeeList")
            console.log(data)

           // console.log(data.profiles.filter(x=>x.payPeriodId===tmpperiodId))
            this.setState({
                isloading       :   false,
                // employeeDDL : data.employees,
                // combineDataw : data.employees

            })
            
          /*   if(data.status=="0"){
                this.setState({
                    isloading       :   false,
                    alerttype       :   "Error!",
                    isshow          :   true,
                    color           :   "danger",
                    message         :   data.message,
                    fade            :   true
                })
            } */
        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true
            })
        })
    };

    handleEmployeeChanged = (e) =>{
        let a = this.state.PayrollFilesdata
        console.log(a)
        if(e.length == 0) {
            this.setState({
              combineDataw : []
            })
            return
        } 
       console.log("EVENT")
       console.log(e)
       this.setState({combineDataw : e})
      // console.log(a.filter(x=>x.payPeriodId===tmpperiodId))

       
    } ;

    GetDataGrid = async() => {
       
        // this.setState({isloading:true})
        // let param = {
        // "IpAddress"         :   "0.0.0.0",
        // "ClientId"          :   "",
        // "UserId"            :   "35954",
        // "ProfileId"            :   ""
        // };
        // await axios
        // .post(AppConfiguration.Setting().noserapiendpoint + "Clearance/GetClearance",  param)
        // .then(res => {
        //     let data = res.data.clearance;   
        //     console.log('data')
        //     console.log(data)
        //     let filterData = data.filter(x=>x.isFinalized==="1" && parseFloat(x.isClearanceStatus)>=8 && x.netPay>0)
        //     // // console.log("filterData")
        //     // // console.log(filterData)
        //     if(data.length > 0) {
        //         this.setState({
        //             payrollDataArry : filterData.sort((a, b) => new Date(a.id) > new Date(b.id) ? 1 : -1),
        //             _tmpData: filterData.sort((a, b) => new Date(a.dateCreated) > new Date(b.dateCreated) ? -1 : 1)
        //         })
        //     }
        //     let _filteredBatch = filterData.filter( x => x.batchPayroll !== "")
            
        //     let _BatchNumberDDL = _filteredBatch.filter((thing, index, self) =>
        //         index === self.findIndex((t) => (
        //             t.batchPayroll === thing.batchPayroll
        //         ))
        //     )
        //     console.log("filteredBatch")
        //     console.log(_BatchNumberDDL.length>0?_BatchNumberDDL.sort((a, b) => a.batchPayroll > b.batchPayroll ? -1 : 1):[])
        //     this.setState({
        //         filteredBatch    : _BatchNumberDDL.length>0?_BatchNumberDDL.sort((a, b) => a.batchPayroll > b.batchPayroll ? -1 : 1):[],
        //         // isloading   : false,
        //     });
            
        //     if(data.status==="0"){
        //         this.setState(  {
        //             isloading       :   false,
        //             alerttype       :   "Error!",
        //             isshow          :   true,
        //             color           :   "danger",
        //             message         :   data.message,
        //             fade            :   true
        //         })
        //     }
        // })
        // .catch(error=>{
        //     this.setState(  {
        //         isloading       :   false,
        //         alerttype       :   "Error!",
        //         isshow          :   true,
        //         color           :   "danger",
        //         message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
        //         fade            :   true
        //     })
        // })
        //this.GetEmployees()
    };
    handleSubmit = async(e) =>{
        this.setState({
            //isloading:true,
            //disablesubmit:true
        })

        /* if(this.state.combineDataw.filter(x=>x.isModified==="1").length>0){
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "Please enter BDO batch no.",
                fade        :   true,
                disablesubmit:  false
            })
            return 
        } */

        
        
        let employeePayrolls = []

        this.state.combineDataw.filter(x=>x.isSelect==="1").map(function(itm,idx){
            employeePayrolls.push(itm)
            console.log(itm)
        })
        let a = employeePayrolls
        console.log("aaaaaaaaa")
        console.log(a)
        a.forEach(element => {
            element.employeeId = element.id
            element.amount = String(parseFloat(element.amount).toFixed(2))

            
        });
        
        const param = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.selectedClientId,
            "UserId":this.state.userinfo.userId,
            "PayPeriodId":this.state.payPeriodSelectedId,
            "BDOBatchNumber"        :   this.state.bdoBatchNo,
            "MLBatchNumber"         :   this.state.mlBatchNo,
            "MetroBankBatchNumber"  :   this.state.mbBatchNo,
            "PalawanBatchNumber"    :   this.state.palawanBatchNo,
            "UBBatchNumber"         :   this.state.ubBatchNo,
            "employeePayrolls": a,
            //"IsHold":"1",
            "IsClearance" : "2",
        };

        console.log("param")
        console.log(param)
        
        await axios
            .post(
                AppConfiguration.Setting().noserapiendpoint + "Accounting/ProcessPayrollFiles",  param
            )
            .then(res => {
                const data = res.data;
                console.log("RESPONCE")
                   console.log(res)
                this.setState({
                    isloading   :   false,
                    alerttype   :   res.data.status=="1" ? "Success!" : "!Error",
                    isshow      :   true,
                    color       :   res.data.status=="1" ? "success" : "danger",
                    message     :   data.message,
                    fade        :   true
                });
            })
            .catch(error=>{
                this.setState({
                    isloading   :   false,
                    alerttype   :   "Error!",
                    isshow      :   true,
                    color       :   "danger",
                    message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                    fade        :   true
                })
            })
    }
    handleChangedBDO = (e) => {
        this.setState({
            bdoBatchNo	:   e.target.value
        })
    }

    handleChangedML = (e) => {
        this.setState({
            mlBatchNo	:   e.target.value
        })
    }

    handleChangedMB = (e) => {
        this.setState({
            mbBatchNo	:   e.target.value
        })
    }

    handleChangedPalawan = (e) => {
        this.setState({
            palawanBatchNo	:   e.target.value
        })
    }

    handleChangedUB = (e) => {
        this.setState({
            ubBatchNo	:   e.target.value
        })
    }
    handleModalClose = () => {
        this.props.onHide();            
    }

    ReferenceGridDataModified(oldValue, newValue, id, column) {
        let disable = true
        this.state.combineDataw.map(function(item,i) {
            if (item.id===id){
                item.isModified = newValue!=oldValue ? "1" : "0"
                disable = newValue!=oldValue ? false : true
            }
            console.log(item.checked)
        })
       // this.setState({disableRemoveEducation:disable})
    }
    render() {
        const dataGridw = [
            {
                text        :   "Member Name",
                editable    :   false,
                dataField   :   "employeeName",
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'35%' }},
                style:{textAlign:'left',width:'35%'},
            },
            {
                text        :   "Paycard Type",
                editable    :   false,
                dataField   :   "payCardType",
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center',width:'20%' }},
                style:{textAlign:'left',width:'20%'},
            },
            {
                text        :   "Paycard No.",
                editable    :   false,
                dataField   :   "payCardNumber",
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'15%' }},
                style:{textAlign:'left',width:'15%'},
            },
            {
                text        :   "Amount",
                editable    :   true,
                dataField   :   "amount",
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'right',width:'10%' }},
                style:{textAlign:'right',width:'10%'},
            },
            {
                text        :   "Remarks",
                editable    :   true,
                dataField   :   "remarks",
                /* headerStyle: () => {
                    return { width: "20%" };
                } */
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'20%' }},
                style:{textAlign:'left',width:'20%'},
            },
        ]
       
        const selectRowBDO = {
            mode: 'checkbox',
            hideSelectAll: false,
            clickToSelectAndEditCell: true,
            onSelect: (row, isSelect, rowIndex, e) => {
                console.log(row)
                 console.log(isSelect)
                this.state.combineDataw.map(function(item,i){
                    if(item.id===row.id)
                    {
                        console.log(item)
                        item.isSelect = isSelect ? "1" : "0"
                    }
                })
            },
            /* onSelectAll: (isSelect, rows) => {
                let isDisable = true
                this.state.combineDataw.map(function(itm){
                    itm.isModified=isSelect ? "1" : "0"
                    if(itm.isModified=="1")
                        isDisable=false
                })
                this.setState({disableReference:isDisable})
            } */
        };
      
    return(
        
            <Modal
                {...this.props}
                return
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        RE- GENERATE PAYROLL FILE 
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Alert isOpen={this.state.isshow} color={this.state.color} fade={this.state.fade} className={this.state.isshow ? 'display-block' : 'display-none'}>
                            <div className={this.state.color}></div> 
                            {this.state.message}
                        </Alert>
                        <Form>
                        <Form.Row>
                            <Form.Group as={Col} sm={6} >
                                <Typeahead
                                    clearButton
                                    labelKey='name'
                                    id="basic-example"
                                    onChange={this.onChangeClientList}
                                    options={this.state.clientListAutocomplete}
                                    placeholder="Select Client"
                                />
                                {/* <Form.Control 
                                    name='clientName'
                                    type="text" 
                                    value={this.state.clientName}
                                    //disabled
                                /> */}
                            </Form.Group>
                            <Form.Group as={Col} sm={6} >
                                <Typeahead
                                    clearButton
                                    labelKey='payPeriod'
                                    id="basic-example"
                                    onChange={this.onChangePayPeriod}
                                    options={this.state.payPeriodListAutocomplete}
                                    placeholder="Select Pay Period"
                                />
                                {/* <Form.Control 
                                    name='periodName'
                                    type="text" 
                                    value={this.state.periodName}
                                    disabled
                                /> */}
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} sm={6} >
                                <Typeahead
                                    labelKey='employeeName'
                                    id="basic-example"
                                    onChange={this.handleEmployeeChanged}
                                    options={this.state.employeeDDL}
                                    placeholder="Select Employee"
                                />
                            </Form.Group>
                            <Form.Group as={Col} sm={6} >
                                <Form.Control 
                                    name='bdoBatchNo'
                                    type="text" 
                                    value={this.state.bdoBatchNo}
                                    placeholder="BDO Batch No"
                                    onChange={this.handleChangedBDO}
                                    autoComplete="off"
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} sm={6} >
                                <Form.Control 
                                    name='mlBatchNo'
                                    type="text" 
                                    value={this.state.mlBatchNo}
                                    placeholder="ML Batch No"
                                    onChange={this.handleChangedML}
                                    autoComplete="off"
                                />
                            </Form.Group>
                            <Form.Group as={Col} sm={6} >
                                <Form.Control 
                                    name='mbBatchNo'
                                    type="text" 
                                    value={this.state.mbBatchNo}
                                    placeholder="METRO BANK Batch No"
                                    onChange={this.handleChangedMB}
                                    autoComplete="off"
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} sm={6} >
                                <Form.Control 
                                    name='palawanBatchNo'
                                    type="text" 
                                    value={this.state.palawanBatchNo}
                                    placeholder="PALAWAN Batch No"
                                    onChange={this.handleChangedPalawan}
                                    autoComplete="off"
                                />
                            </Form.Group>
                            <Form.Group as={Col} sm={6} >
                                <Form.Control 
                                    name='ubBatchNo'
                                    type="text" 
                                    value={this.state.ubBatchNo}
                                    placeholder="UB Batch No"
                                    onChange={this.handleChangedUB}
                                    autoComplete="off"
                                />
                            </Form.Group>
                        </Form.Row>
                        </Form>
                        {/* <Card>
                            <Card.Body style={{border:"none !important"}}> */}
                            <Form.Row>
                                <Form.Group controlId="formGridPassword" as={Col}>
                                    
                                    <BootstrapTable
                                        keyField = "id"
                                        data = { this.state.combineDataw }
                                        columns = { dataGridw }
                                        striped
                                        hover
                                        condensed
                                        rowClasses="noser-table-row-class"
                                        cellEdit = { cellEditFactory({
                                            mode: 'dbclick',
                                            blurToSave: true,
                                            afterSaveCell: (oldValue, newValue, row, column) => {
                                                this.ReferenceGridDataModified(oldValue, newValue, row.id, column.dataField)
                                                }
                                            })
                                        }
                                        selectRow={selectRowBDO}
                                        noDataIndication={ () => <div>No record found.</div> }
                                    />
                                    
                                </Form.Group>
                            </Form.Row>
                                {/* <Tabs defaultActiveKey="default" transition={false} id="noanim-tab-example">
                                    <Tab eventKey="default" title="BDO">
                                        <Form.Row>
                                            <Form.Group controlId="formGridPassword" as={Col}>
                                                <Card className="card-tab-no-border">
                                                    <div className="card-header-tab"></div>
                                                    <BootstrapTable
                                                        keyField = "id"
                                                        data = { this.state.bdoGRID }
                                                        columns = { colGrid }
                                                        striped
                                                        hover
                                                        condensed
                                                        selectRow={selectRowBDO}
                                                        noDataIndication={ () => <div>No record found.</div> }
                                                    />
                                                </Card>
                                            </Form.Group>
                                        </Form.Row>
                                    </Tab>

                                    <Tab eventKey="metrobank" title="METROBANK">
                                        <Form.Row>
                                            <Form.Group controlId="formGridPassword" as={Col}>
                                                <Card className="card-tab-no-border">
                                                    <div className="card-header-tab"></div>
                                                    <BootstrapTable
                                                        keyField = "id"
                                                        data = { this.state.mbGRID }
                                                        columns = { colGrid }
                                                        striped
                                                        hover
                                                        condensed
                                                        selectRow={selectRowMB}
                                                        noDataIndication={ () => <div>No record found.</div> }
                                                    />
                                                </Card>
                                            </Form.Group>
                                        </Form.Row>
                                    </Tab>

                                    <Tab eventKey="ml" title="ML">
                                        <Form.Row>
                                            <Form.Group controlId="formGridPassword" as={Col}>
                                                <Card className="card-tab-no-border">
                                                    <div className="card-header-tab"></div>
                                                    <BootstrapTable
                                                        keyField = "id"
                                                        data = { this.state.mlGRID }
                                                        columns = { colGrid }
                                                        striped
                                                        hover
                                                        condensed
                                                        selectRow={selectRowML}
                                                        noDataIndication={ () => <div>No record found.</div> }
                                                    />
                                                </Card>
                                            </Form.Group>
                                        </Form.Row>
                                    </Tab>

                                    <Tab eventKey="palawan" title="PALAWAN">
                                        <Form.Row>
                                            <Form.Group controlId="formGridPassword" as={Col}>
                                                <Card className="card-tab-no-border">
                                                    <div className="card-header-tab"></div>
                                                    <BootstrapTable
                                                        keyField = "id"
                                                        data = { this.state.palawanGRID }
                                                        
                                                        columns = { colGrid }
                                                        striped
                                                        hover
                                                        condensed
                                                        selectRow={selectRowPalawan}
                                                        noDataIndication={ () => <div>No record found.</div> }
                                                    />
                                                </Card>
                                            </Form.Group>
                                        </Form.Row>
                                    </Tab>

                                    <Tab eventKey="ub" title="UB">
                                        <Form.Row>
                                            <Form.Group controlId="formGridPassword" as={Col}>
                                                <Card className="card-tab-no-border">
                                                    <div className="card-header-tab"></div>
                                                    <BootstrapTable
                                                        keyField = "id"
                                                        data = { this.state.ubGRID }
                                                        columns = { colGrid }
                                                        striped
                                                        hover
                                                        condensed
                                                        selectRow={selectRowUB}
                                                        noDataIndication={ () => <div>No record found.</div> }
                                                    />
                                                </Card>
                                            </Form.Group>
                                        </Form.Row>
                                    </Tab>
                                </Tabs> */}
                            {/* </Card.Body>
                        </Card> */}
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <ButtonToolbar >
                        <Button variant="success" className="ml-auto noser-button-mr1" onClick = { this.handleSubmit } disabled={this.state.disablesubmit}>GENERATE</Button>
                        <Button variant="danger" className='noser-button-mr15' onClick={this.props.onHide}>Close</Button>
                    </ButtonToolbar>
                </Modal.Footer>
                <NoserLoading show={this.state.isloading} />
        </Modal>
        );
    }
}
export default ReGeneratePayFileModal